import type { Hierachy } from "hooks/useHierarchyData";
import { APPLICATION_UI_CONFIG } from "./applicationConfig";
import type { CategoryItem } from "./categoryItem";
import { DEFAULT_CATEGORY_CONFIG } from "./discoveryDefaults";

export function mapHierarchyToApplicationItems(
  hierarchyData: Hierachy[],
): CategoryItem[] {
  return hierarchyData.map((item) => {
    const uiConfig = APPLICATION_UI_CONFIG[item.industry];
    if (!uiConfig)
      console.warn(`[applicationData] No UI config for: "${item.industry}"`);
    const { image, accentColor } = uiConfig ?? DEFAULT_CATEGORY_CONFIG;
    return {
      id: item.industry.toLowerCase().replace(/\s+/g, "-"),
      name: item.industry,
      description: item.description ?? "",
      filterValue: { name: item.industry, value: item.industry },
      image,
      accentColor,
    };
  });
}
